import { TabStyles } from '@tableau/widgets';
import { divWithStyle } from './LayoutComponents';
import { flexColumnStyle, flexRowStyle } from './LayoutStyles';
import { cssClass } from './StyleFunctions';
import {
  actionsMenuStyle,
  headerIconContainerStyle,
  headerIconStyle,
  headerPaddingStyle,
  placeHeaderTitleStyle,
  vizPortalFontStyle,
  vizPortalLowDpiFontStyle,
} from './VizPortalStyles';

const Typography = TabStyles.Typography;
const Spacing = TabStyles.Spacing;

export const PlacePageHeader = divWithStyle('PlacePageHeader', headerPaddingStyle);

export const PlacePageTitleContainer = divWithStyle('PlacePageTitleContainer', flexRowStyle);

export const PlacePageMastheadContainer = divWithStyle('PlacePageMastheadContainer', {
  ...flexColumnStyle,
  minWidth: 0,
});

export const PlacePageMastheadRowContainer = divWithStyle('PlacePageMastheadRowContainer', {
  ...flexRowStyle,
  flex: '1 1 auto',
  marginBottom: Spacing.MediumSpace,
  minWidth: 0,
});

export const placePageIconContainerClass = cssClass('PlacePageIconContainer', headerIconContainerStyle);

export const placePageIconClass = cssClass('PlacePageIcon', headerIconStyle);

export const PlacePageTitle = divWithStyle('PlacePageTitle', placeHeaderTitleStyle);

export const PlacePageActionsMenu = divWithStyle('PlacePageActionsMenu', actionsMenuStyle);

export const PlaceHeaderMetadataItem = divWithStyle('PlaceHeaderMetadataItem', {
  fontSize: Typography.Sizing.Default,
  color: Typography.Color.Disabled,
  paddingRight: Spacing.LargeSpace,
  verticalAlign: 'middle',
  alignItems: 'center',
  display: 'inline-flex',
});


export const placeHeaderMetadataLabelClass = cssClass('placeHeaderMetadataLabel', {
  ...vizPortalFontStyle,
  paddingRight: TabStyles.Spacing.DefaultSpace,
});

export const placeHeaderMetadataValueClass = cssClass('placeHeaderMetadataValue', {
  ...vizPortalLowDpiFontStyle,
});
